const isEmptyArray = (arr: any) => Array.isArray(arr) && arr.length === 0;

export default isEmptyArray;
